import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip, Glyphicon } from '@bingads-webui-react/primitive';
import { withOverflowProp } from '@bingads-webui-react/with-overflow-prop';
import { curlyTemplate } from '@bingads-webui-universal/primitive-utilities';

const OverflowCriteriaItemsContent = withOverflowProp(({
  targets, isTextOverflow, forwardedRef, i18n, renderEditIcon,
}) => (
  <div className="entity-text entity-multi-content">
    <OverlayTrigger
      key="top"
      placement="top"
      overlay={
        <Tooltip
          id="top"
          className={isTextOverflow ? '' : 'hide'}
        >
          {targets[0]}
        </Tooltip>
      }
    >
      <span ref={forwardedRef} className="entity-first-item">{targets[0]}</span>
    </OverlayTrigger>
    {targets.length > 1 && (
      <span className="entity-more">
        {curlyTemplate(i18n.getString(_TL_('and {{restNumber}} More...')))({
          restNumber: targets.totalCount && targets.totalCount > 1 ? targets.totalCount - 1 : targets.length - 1,
        })}
      </span>)
    }
    {renderEditIcon()}
  </div>
));

const CriteriaItemsInternal = ({
  targets, emptyValue, i18n, canEdit,
}) => {
  const renderEditIcon = () => (canEdit ? (
    <Glyphicon
      className="entity-icon"
      glyph="ba-Edit"
    />
  ) : null);

  if (!(targets && targets.length)) {
    return (
      <div className="entity-text">
        <span>{emptyValue}</span>
        {renderEditIcon()}
      </div>
    );
  }

  return (<OverflowCriteriaItemsContent
    i18n={i18n}
    targets={targets}
    renderEditIcon={renderEditIcon}
  />);
};

CriteriaItemsInternal.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  targets: PropTypes.array,
  emptyValue: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  canEdit: PropTypes.bool,
};

CriteriaItemsInternal.defaultProps = {
  targets: [],
  canEdit: false,
};

export const CriteriaItems = CriteriaItemsInternal;
